import { Directive, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Directive({
  selector: '[appHideOnEvent]'
})
export class HideOnEventDirective {

  constructor(private el: ElementRef, private router: Router) {
    if (this.isEventPage(this.router.url)) {
      el.nativeElement.style.display = "none";
    }
    else {
      el.nativeElement.style.display = "block";
    }
    router.events.subscribe((route) => {
      if (route instanceof NavigationEnd && this.isEventPage(route.url)) {
        el.nativeElement.style.display = "none";
      }
      else {
        el.nativeElement.style.display = "block";
      }
    });
  }

  isEventPage = (url: string): boolean => url !== "/ateliersnumeriques"

}



// WEBPACK FOOTER //
// ./src/app/helper/directives/hide-on-event.directive.ts